
export const XIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        d="M14.31 12l6.21-6.21a1.63 1.63 0 10-2.31-2.31L12 9.69 5.79 3.48a1.63 1.63 0 00-2.31 2.31L9.69 12l-6.21 6.21A1.64 1.64 0 004.64 21a1.61 1.61 0 001.15-.48L12 14.31l6.21 6.21a1.61 1.61 0 001.15.48 1.64 1.64 0 001.16-2.79z"
      />
    </svg>
  );
};
